import { setDialog } from "slices/appSlice";
// import ajv from "validation";
export const exportData = (
  data,
  fileName = "export",
  type = "text/csv;charset=utf-8;"
) => {
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const formErrorStrfromObj = (e) => {
  let str = e.message ? e.message + ".\n" : "";
  e?.response?.data?.errors?.forEach((er) => {
    str += er + "\n";
  });
  // if (!str) {
  //   return e.message;
  // }
  return str;
};

export const getHealthplanName = (groupName) => {
  const textArray = groupName.split("-");
  const nameElement = textArray[2];
  const clientName = nameElement.split("_")[0];

  return clientName;
};

export const hasSkill = (userContext, skills) => {
  return (
    userContext?.groups[0] === "POET-Avalon-Admin" ||
    skills.some((skill) =>
      userContext?.POETSkill?.some(
        (userSkill) => userSkill.toLowerCase() === skill.toLowerCase()
      )
    )
  );
};

export const isString = (value) =>
  typeof value === "string" || value instanceof String;

export const sanitizeCC = (str) => {
  return [...new Set(str.split(",").map((ccNumber) => ccNumber.trim()))]
    .sort((a, b) => a - b)
    .join(",");
};

export const hasUserGroup = (userContext, groups) => {
  return groups.some((group) =>
    userContext?.groups[0]?.toLowerCase().includes(group.toLowerCase())
  );
};

export const userHasAllowedGroup = (user, groups) => {
  if (!user?.groups || !groups) return false;

  return user.groups.some((userGroup) =>
    groups.some((group) => userGroup.toLowerCase() === group.toLowerCase())
  );
};
export const userHasRuleBuilderAccess = (user) =>
  userHasAllowedGroup(user, ["Poet-Avalon-Admin"]) ||
  (userHasAllowedGroup(user, ["POET-Avalon-POE"]) &&
    user?.POETSkill?.includes("RuleEditor"));
export const compareCCValues = (currentCC, newCC) => {
  const currentCCList = currentCC
    ? currentCC.split(",").map((cc) => cc.trim())
    : [];
  const newCCList = newCC ? newCC.split(",").map((cc) => cc.trim()) : [];

  const added = newCCList.filter(
    (cc) => !currentCCList.includes(cc) && cc.replace(",", "").trim() !== ""
  );
  const removed = currentCCList.filter(
    (cc) => !newCCList.includes(cc) && cc.replace(",", "").trim() !== ""
  );

  return { added, removed };
};

export const isClobValid = (workSpace, dispatch) => {
  // const validate = ajv.getSchema("workspace");
  // if (!validate(workSpace)) {
  //   dispatch(
  //     setDialog({
  //       title: "Validation Error",
  //       message:
  //         "Workspace data is invalid. Please check the console for details.",
  //     })
  //   );
  //   console.error("Validation errors:", validate.errors);
  //   return false;
  // }
  return true;
};

export const showVarianceIcon = (RuleHeader, selectedHealthPlan) => {
  return (
    (["NEW", "VARIANCE"].includes(RuleHeader?.EditRule) ||
      RuleHeader?.RuleVersion?.includes("-")) &&
    selectedHealthPlan !== "AHCS"
  );
};
